module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAaCAYAAABLlle3AAAABGdBTUEAALGPC/xhBQAAAM1JREFUSA1j5BZV28rA8N+LgW6AcRsjt6jqf7rZB7WIid4WguwbtZSmoT4avKPBixECYoLsDOxspCUN0lRjWMnAwMvFzLCt35LBzVwMiyx2IaKLQRMNAQYTLQGspgjxsTL42koyLNz6mGHGuvtY1SALUuxTZMOIZRPtU1wGKktzMcyqMmToXHSbYdfJV7iUoYhTbCkoIX38+pvh569/KAbj47DgkyRG7tX7n8QoQ1EzIHE6ailKHFCbMxq81A5RFPMGKngZt6E4g+Ycxq0AyBsg5FIj3JwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/button_r1.png
// module id = eDBZ
// module chunks = 1